import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ContentAuthoringService } from 'src/app/services/content-authoring.service';
import { jsPDF } from "jspdf";
import { DatePipe } from '@angular/common';
import { environment } from '../../../environments/environment';
import { CourseService } from "../../services/course.service";

@Component({
  selector: 'app-user-deactive',
  templateUrl: './user-deactive.component.html',
  styleUrls: ['./user-deactive.component.scss'],
  providers: [DatePipe]
})
export class UserDeactiveComponent implements OnInit {
  adminData: any; userID:any; userDetail:any;
  constructor(private modalService: NgbModal,private authCours: CourseService, private contentAuthoringApi: ContentAuthoringService,
    private route: ActivatedRoute,private datePipe: DatePipe,
    private router: Router, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.adminData=JSON.parse(localStorage.getItem('adminData') || '[]');
    this.route.queryParams.subscribe(params => {
      const id = +params.user_id;
      if (id > 0) {
        this.userID = id;
      }
    this.getUserDetail(this.userID);
    })
  }
  getUserDetail(userID:any) {
    this.spinner.show();
    this.contentAuthoringApi.getUserDetail(userID).subscribe(
      (data) => {
        // console.log('kkkkkkkkkkkkkkk',data)
        this.userDetail=data.userList;
      },
      (error) => {
        this.spinner.hide();
       // this.errorInfo.errorMsg = error;
      },
    );
  }
  changeIsDeActiveVal(user_id: any, is_actives: any) {
    this.changeIsActiveVal(user_id, is_actives);
  }
  changeIsActiveVal(user_id: any, is_active: any) {
    this.contentAuthoringApi.changeUserIsActiveVal(user_id, is_active).subscribe(
      (data) => {
        if (data.status == 200) {
          this.router.navigate(['/user']);
        }
      },
      (error) => {
        //this.errorInfo.errorMsg = error;
      },
    );
   }

}
